import { gql, TypedDocumentNode } from '@common/hooks';
import {
  DeleteWorkerProfileChangeMutationCgResponse,
  DeleteWorkerProfileChangeMutationVariables,
} from '@common/graphql';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

// Deletes a future-dated worker profile change (WORK-6258). The returned worker carries its
// healed term history (same selection as LOAD_BALANCING_WORKER_QUERY) so the read views
// update in place.
export const DELETE_WORKER_PROFILE_CHANGE_MUTATION: TypedDocumentNode<
  DeleteWorkerProfileChangeMutationCgResponse,
  DeleteWorkerProfileChangeMutationVariables
> = gql`
  mutation DeleteWorkerProfileChange(
    $workerId: ID!
    $termId: ID!
    $schedulingPeriodId: ID
  ) {
    deleteWorkerProfileChange(
      workerId: $workerId
      termId: $termId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      worker {
        id
        name
        terms {
          id
          active
          effectiveStartDate
          effectiveEndDate
          employmentType
          role
          homeUnit
          fteHours
          ftePercentage
          preferredTime
          chargeEligible
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
